import { createSlice } from '@reduxjs/toolkit';
import { fetchSearchLimitStatus } from './actions';

const initialState = {
  error_429: {
    type: 'quarter',
    remainingTime: null,
    active: false,
    loading: true,
    error: null,
  },
};

export const errorSlice = createSlice({
  name: 'errorSlice',
  initialState,
  reducers: {
    setError429: (state, action) => {
      const { type = 'quarter', active, ttl = 0 } = action.payload;
      state.error_429.type = type;
      state.error_429.active = active;
      state.error_429.remainingTime = ttl;
    },
    subtractSecondFromErrorTTL: (state, action) => {
      const { error, second } = action.payload;
      state[error].remainingTime = state.error_429.remainingTime - second;

      if (state.error_429.remainingTime - second <= 0) {
        state[error].active = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchLimitStatus.pending, (state) => {
        state.error_429.error = null;
        state.error_429.loading = true;
      })
      .addCase(fetchSearchLimitStatus.rejected, (state, action) => {
        state.error_429.error = action.payload;
        state.error_429.loading = false;
      });
  },
});

export const { setError429, subtractSecondFromErrorTTL } = errorSlice.actions;
